const URL_ME = process.env.VUE_APP_ME_HOST
const URL_MANAGER = process.env.VUE_APP_MANAGER_HOST
const URL_API = process.env.VUE_APP_API_URL

const unobservable = variable => {
  return JSON.parse(JSON.stringify(variable))
}

const isset = variable => {
  return typeof variable !== "undefined" && variable !== null
}

const comeFromManager = () => {
  return window.location.host.startsWith(URL_MANAGER)
}

const comeFromMe = () => {
  return window.location.host.startsWith(URL_ME)
}

export { unobservable, isset, comeFromManager, comeFromMe, URL_ME, URL_MANAGER, URL_API }
